import React from 'react';
import './Card.css';

/**
 * Card container component
 */
const Card = React.forwardRef(({ className = '', children, ...props }, ref) => {
    return (
        <div ref={ref} className={`card ${className}`} {...props}>
            {children}
        </div>
    );
});
Card.displayName = 'Card';

/**
 * Card header section
 */
const CardHeader = React.forwardRef(({ className = '', children, ...props }, ref) => {
    return (
        <div ref={ref} className={`card-header ${className}`} {...props}>
            {children}
        </div>
    );
});
CardHeader.displayName = 'CardHeader';

/**
 * Card title
 */
const CardTitle = React.forwardRef(({ className = '', children, as: Component = 'h3', ...props }, ref) => {
    return (
        <Component ref={ref} className={`card-title ${className}`} {...props}>
            {children}
        </Component>
    );
});
CardTitle.displayName = 'CardTitle';

/**
 * Card description
 */
const CardDescription = React.forwardRef(({ className = '', children, ...props }, ref) => {
    return (
        <p ref={ref} className={`card-description ${className}`} {...props}>
            {children}
        </p>
    );
});
CardDescription.displayName = 'CardDescription';

/**
 * Card action (typically for header actions like links/buttons)
 */
const CardAction = React.forwardRef(({ className = '', children, ...props }, ref) => {
    return (
        <div ref={ref} className={`card-action ${className}`} {...props}>
            {children}
        </div>
    );
});
CardAction.displayName = 'CardAction';

/**
 * Card content section
 */
const CardContent = React.forwardRef(({ className = '', children, ...props }, ref) => {
    return (
        <div ref={ref} className={`card-content ${className}`} {...props}>
            {children}
        </div>
    );
});
CardContent.displayName = 'CardContent';

/**
 * Card footer section
 */
const CardFooter = React.forwardRef(({ className = '', children, ...props }, ref) => {
    return (
        <div ref={ref} className={`card-footer ${className}`} {...props}>
            {children}
        </div>
    );
});
CardFooter.displayName = 'CardFooter';

export {
    Card,
    CardHeader,
    CardTitle,
    CardDescription,
    CardAction,
    CardContent,
    CardFooter
};
